import { editorThemeColors } from "@/components/FullPageEditor/utils/editorThemeColors";
import Box, { BoxProps } from "@mui/material/Box";
import clsx from "clsx";

const TOCItemText = ({ children, style, className, level, href, ...props }: BoxProps<"a"> & { level: number }) => {
    return (
        <Box
            component="a"
            href={href}
            className={clsx(className, "ellipsisText")}
            sx={{
                cursor: "pointer",
                textDecoration: "none",
                marginLeft: `${1 * level - 1}rem`,
                padding: "0.4rem 0.4rem 0.4rem 0.4rem",
                borderRadius: "0.3rem",
                flexShrink: 0,
                "&:hover": {
                    backgroundColor: editorThemeColors.selected,
                },
                ...style,
            }}
            {...props}>
            {children}
        </Box>
    );
};

export default TOCItemText;
